import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import { calculateDuration, formatDate, formatDateTime } from "../../../../common/Validations";

const MachineIdleStatusReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);

  const columnsData = [
    {
      name: t("msg_reports.msg_machine_idle_status.reported_date"),
      selector: (row) => row.reportDate,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
             {formatDate(row.reportDate)}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.reported_from"),
      selector: (row) => row.idleFrom,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
             {formatDateTime(row.idleFrom)}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.reported_to"),
      selector: (row) => row.idleTo,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
             {row.idleTo || "-"}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.duration"),
      selector: (row) => row.idleTo,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
             {calculateDuration(row.idleFrom, row.idleTo)}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.department"),
      selector: (row) => row.deptCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.deptCode} - {row.deptName}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.machine"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.machineCode} - {row.machineName}{" "}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.reason_code"),
      selector: (row) => row.idleReasonCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.idleReasonCode}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.reason_name"),
      selector: (row) => row.idleReasonName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.idleReasonName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.remarks"),
      selector: (row) => row.remarksIdle,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.remarksIdle} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.status"),
      selector: (row) => row.status,
      sortable: true,
      width: "160px",
      cell: (row) => (
         <>
          {row.status === Constants.MASTER.STATUS.Complete ? (
            <span className="bg-table-status bg-table-success-status">
              {row.status}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Idle ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.status}
            </span>
          ) : (
            row.status
          )}
        </>
        // <>
        //   <span className="bg-table-status bg-table-progress-status">
        //     {row.status}
        //   </span>
        // </>
      ),
    },
    {
      name: t("msg_reports.msg_machine_idle_status.reported_by"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.loginUserId}- {row.loginUserName}
          </p>
        </div>
      ),
    },
  ];

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t(
                "msg_reports.msg_machine_idle_status.machine_idle_status_reports"
              )}
            </h2>
            <p className="subText">
              {t("msg_reports.msg_machine_idle_status.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>

      <div>
        <ReportList
          columnsData={columnsData}
          displayFilter={displayFilter}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.msg_machine_idle_status.machine_idle_status_reports"
          )}
          pageURL={Constants.REPORTS.MACHINEIDLESTATUS.list}
          name={Constants.REPORTS.MACHINEIDLESTATUS.name}
          selectableRows
        />
      </div>
    </main>
  );
};

export default MachineIdleStatusReports;
